import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { OrderEmergensiPayload } from "@/types/order_emergensi";

function tangkap(err) {
  ErrorAlert.showErrorAlert(err);
  return Promise.reject(err);
}

async function getPaketAktif() {
  return http.getData("/order-emergensi/paket-aktif").catch(tangkap);
}

async function getByRegister(registerId: string | number) {
  return http.getData(`/register/${registerId}/order-emergensi`).catch(tangkap);
}

async function find(id: number) {
  return http.getData(`/order-emergensi/${id}`).catch(tangkap);
}

async function resolveDepo(
  registerId: string | number,
  lokasiUnitId: string,
  zona: string | null
) {
  return http
    .getDataParam(`/register/${registerId}/order-emergensi/depo`, {
      params: { lokasi_unit_id: lokasiUnitId, zona: zona || undefined }
    })
    .catch(tangkap);
}

async function create(data: OrderEmergensiPayload) {
  return http.postData("/order-emergensi", data).catch(tangkap);
}

async function update(id: number, data: OrderEmergensiPayload) {
  return http.putData(`/order-emergensi/${id}`, data).catch(tangkap);
}

async function batal(id: number, alasanBatal: string) {
  return http
    .putData(`/order-emergensi/${id}/batal`, { alasan_batal: alasanBatal })
    .catch(tangkap);
}

async function sign(id: number, password: string) {
  return http.putData(`/order-emergensi/${id}/sign`, { password }).catch(tangkap);
}

async function getCpoByRegister(registerId: string | number) {
  return http.getData(`/register/${registerId}/order-emergensi/cpo`).catch(tangkap);
}

function print(id: number) {
  window.open(`${http.getAPI()}/order-emergensi/${id}/pdf`, "_blank");
}

export default {
  getPaketAktif,
  getByRegister,
  find,
  resolveDepo,
  create,
  update,
  batal,
  sign,
  getCpoByRegister,
  print
};
